/**
 * Pure text/caret transforms for the Composer's autocomplete inserts,
 * extracted so the string + cursor math is testable without a textarea or
 * React. The component keeps the DOM side (reading selectionStart, focusing,
 * setSelectionRange); these functions only compute the next draft + caret.
 */

/**
 * Leading slash-command query at the message head. The slash popup is
 * deliberately leading-only (`/word` with no whitespace yet) — there's no
 * mid-message slash chain. Returns the lowercased partial (`''` for a bare
 * `/`) or null when the head isn't a slash token.
 */
export function detectSlashQuery(value: string): string | null {
  const m = value.match(/^\/([\w-]*)$/);
  if (!m) return null;
  return (m[1] ?? '').toLowerCase();
}

/**
 * Text the draft becomes when a slash command is picked. Commands that take a
 * body argument (the menu label ends with `>`) get a trailing space so the
 * body is ready to type (`/me `); arg-less commands (`/shrug`) get none.
 */
export function slashPickText(cmd: string, needsBody: boolean): string {
  return needsBody ? `/${cmd} ` : `/${cmd}`;
}

// The mention splice now lives in `@bunker/shared/mentions` (shared with the RN
// composer); re-exported here so the Composer's `from './composerText'` import
// is unchanged.
export { insertMention, type MentionInsert } from '@bunker/shared/mentions';
